import { OnInit, Component, NgZone, HostListener } from '@angular/core';
import { ThirdPartyDocumentsService } from '../../services/thirdparty-documents/thirdparty-documents.service';
import { CaasService } from '../../services/caas/caas.service';
import { GatekeeperService } from '../../services/gatekeeper/gatekeeper.service';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GetAddressesGraphQLResponse, InterestedPartyAddress } from '@app/models/thirdparty-documents.model';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AddressModel, StepIndicatorModel } from '@app/state/models/add-address.model';
import { sendAccounts, setOriginalAddressSnapshot, updateCurrentStep, updateAddress } from '../../state/actions/add-address.action';
import { ThirdpartyDocumentsAemItem } from '@app/models/aem.model';
import { AemUtil } from '@app/utils/aem.util';
import { AemContentService } from '@app/services/aem/aemcontent.service';
import {
  ADD_A_DUPLICATE_STAMENT_ADDRESS_BUTTON,
  ADD_A_DUPLICATE_VANGUARD_529_ADDRESS_BUTTON,
  ADD_DUPLICATE_NEED_TO_KNOW_CHECKLIST,
  ADDRESS_LABEL,
  DUPLICATE_STATEMENTS_CONFIRMATIONS_FLOW_PAGE_CONTAINER,
  INFO_UNAVAILABLE_ERROR_MESSAGE, INFO_UNAVAILABLE_ERROR_MESSAGE_ERROR,
  INTERESTED_PARTY_DUPLICATE_STATEMENTS_CONFIRMATIONS_LINK,
  INTRESTED_PARTY_SELECTOR_WIDGET,
  STATEMENTS_ONLY_LABEL,
  CONFIRMATIONS_ONLY_LABEL,
  STATEMENTS_AND_CONFIRMATIONS_LABEL,
  LANDING_PAGE_CONTAINER,
  NOT_SHOWING_DUPLICATE_ADDRESSES_ERROR_MESSAGE,
  PROFILE_AND_ACOOUNT_SETTINGS_LINK,
  UNABLE_TO_PROCESS_REQUEST_ERROR_MESSAGE,
  VG_529_INTERESTED_PARTY_ADDRESS_INFO_MESSAGE,
  THIRD_PARTY_INTERNAL_ONLY,
  TPQ_529_INTERNAL_ONLY,
} from '@app/constants/aem.constant';

@Component({
  selector: 'app-thirdparty-documents',
  templateUrl: './thirdparty-documents.component.html',
  styleUrls: ['./thirdparty-documents.component.scss'],
  standalone: false,
})
export class ThirdpartyDocumentsComponent implements OnInit {
  NAVIGATION_PATHS = [PROFILE_AND_ACOOUNT_SETTINGS_LINK, INTERESTED_PARTY_DUPLICATE_STATEMENTS_CONFIRMATIONS_LINK];
  ACTIONBUTTON_PATHS = [ADD_A_DUPLICATE_STAMENT_ADDRESS_BUTTON, ADD_A_DUPLICATE_VANGUARD_529_ADDRESS_BUTTON];
  urlSafe: SafeResourceUrl;
  showActionLabel = true;
  isLoaderIndicate = true;
  isSmallButton = false;
  hasCloseControl = false;
  hasDetails = false;
  ftnMessage = '';
  addressLabel = '';
  internal529 = '';
  internalOnlyTPQ = '';
  actionMenuData: any;
  navigationContent: any;
  faqContent: any;
  actionButtonsContent: any;
  thirdpartyDocumentsCaasContent: ThirdpartyDocumentsAemItem;
  thirdPartyDocAddressList: InterestedPartyAddress[] = [];
  is529BtnEnabled = false;
  sso529Href = '';
  contentBody: string;
  contentBodyForCaasError: string;
  shouldShowErrorBanner = false;
  shouldShowErrorBannerForCaas = false;
  errorData: { [p: string]: string };
  defaultErrorCode = UNABLE_TO_PROCESS_REQUEST_ERROR_MESSAGE;
  internalOnlyContent = '';
  isClientOnlyAction = false;
  expandedMenuIndex: number | null = null;
  changeAddressLabel = '';
  deleteAddressLabel = '';
  viewAccountsLabel = '';

  // eslint-disable-next-line max-params
  constructor(
    private readonly caasService: CaasService,
    private readonly thirdPartyDocumentsService: ThirdPartyDocumentsService,
    private readonly sanitizer: DomSanitizer,
    private _router: Router,
    private ngZone: NgZone,
    private store: Store<StepIndicatorModel>,
    private readonly aemContentService: AemContentService,
    private readonly gatekeeperService: GatekeeperService,
  ) {
  }

  async ngOnInit() {
    await this.getCaasData();
    this.getClientOnlyFlag();
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(environment.LEGACY_URL);
    if (window.innerWidth < 768) {
      this.showActionLabel = false;
      this.isSmallButton = true;
    }
    await this.getThirdPartyDocumentsAddressList();
  }

  @HostListener('window:resize')
  onResize() {
    this.showActionLabel = window.innerWidth >= 768;
    this.isSmallButton = window.innerWidth < 768;
  }

  getClientOnlyFlag() {
    if (environment.internal) {
      this.isClientOnlyAction = sessionStorage.getItem('oktaFlag') !== 'true';
    }
  }

  async getCaasData() {
    const response = this.caasService.getCaasData();
    if (response) {
      const container = response?.data?.[DUPLICATE_STATEMENTS_CONFIRMATIONS_FLOW_PAGE_CONTAINER];
      if (container?.item) {
        this.thirdpartyDocumentsCaasContent = container.item;
        this.actionMenuData = AemUtil.buildActionMenuDataFromAem(this.thirdpartyDocumentsCaasContent?.secondaryCta?.children);
        const menuItems = this.actionMenuData?.groups?.[0]?.items ?? [];
        this.changeAddressLabel = menuItems[0]?.labelText || 'Change address and its accounts';
        this.deleteAddressLabel = menuItems[1]?.labelText || 'Delete this address';
        this.viewAccountsLabel = menuItems[2]?.labelText || 'View accounts that use this address';
        this.navigationContent = AemUtil.getThirdpartDocumentsData(this.NAVIGATION_PATHS, this.thirdpartyDocumentsCaasContent.additionalCta?.children);
        this.actionButtonsContent = AemUtil.getThirdpartDocumentsData(this.ACTIONBUTTON_PATHS, this.thirdpartyDocumentsCaasContent.secondaryCta?.children);
        const children = AemUtil.getChildren(LANDING_PAGE_CONTAINER, this.thirdpartyDocumentsCaasContent.children);
        this.thirdpartyDocumentsCaasContent.optimizeLabel = children?.subheading;
        this.faqContent = AemUtil.getFaqOptionsFromPath(ADD_DUPLICATE_NEED_TO_KNOW_CHECKLIST, children?.children);
        this.thirdpartyDocumentsCaasContent.faqTitle = AemUtil.getHeadingFromChildren(ADD_DUPLICATE_NEED_TO_KNOW_CHECKLIST, children?.children);
        this.thirdpartyDocumentsCaasContent.intrestedPartySelectorWidget = AemUtil.getBodyContentFromChildren(INTRESTED_PARTY_SELECTOR_WIDGET, children?.children);
        this.thirdpartyDocumentsCaasContent.statementsOnlyLabel = AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsCaasContent, STATEMENTS_ONLY_LABEL);
        this.thirdpartyDocumentsCaasContent.confirmationsOnlyLabel = AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsCaasContent, CONFIRMATIONS_ONLY_LABEL);
        this.thirdpartyDocumentsCaasContent.statementsAndConfirmationsLabel = AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsCaasContent, STATEMENTS_AND_CONFIRMATIONS_LABEL);
        const tempErrorArr = AemUtil.getTempErrorArrFromMessages(this.thirdpartyDocumentsCaasContent.messages);
        this.errorData = Object.assign({}, ...((tempErrorArr ?? []).map(item => ({ [item.key]: item.value }))));
        this.ftnMessage = AemUtil.getErrorMessagesFromMessages(this.thirdpartyDocumentsCaasContent.messages, VG_529_INTERESTED_PARTY_ADDRESS_INFO_MESSAGE);
        this.addressLabel = AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsCaasContent, ADDRESS_LABEL);
        this.internal529 = AemUtil.getErrorMessagesFromMessages(this.thirdpartyDocumentsCaasContent.messages, TPQ_529_INTERNAL_ONLY);
        this.internalOnlyTPQ = AemUtil.getErrorMessagesFromMessages(this.thirdpartyDocumentsCaasContent.messages, THIRD_PARTY_INTERNAL_ONLY);
      }
    } else {
      this.shouldShowErrorBannerForCaas = true;
      this.contentBodyForCaasError = INFO_UNAVAILABLE_ERROR_MESSAGE;
    }
  }

  async getThirdPartyDocumentsAddressList() {
    try {
      const [accountsData, addressListResponse] = await Promise.all([
        this.getAccountsData(),
        this.getThirdPartyDocuments(),
      ]);

      let allAccounts = accountsData.accounts;
      const addresses = addressListResponse?.data?.currentVgClient?.interestedPartyAddresses ?? [];

      allAccounts.forEach((value: any) => {
        value.sortingState = 'descending';
        if (value.productType.includes('BROKERAGE')) {
          value.activeSort = 'ticker';
          let counter = 0;
          for (let i = 0; i < addresses.length; i++) {
            if (addresses[i]?.associatedAccounts?.find(
              (obj) => obj.accountId === value.accountId
            )) {
              counter++;
            }
          }
          value.noOfLinkedAddresses = counter;
        } else if (value.productType.includes('MUTUAL_FUND')) {
          value.activeSort = 'vanguardFundId';
          value.noOfLinkedAddresses = 0;
          for (let i = 0; i < value.positions.length; i++) {
            let mutualFundCounter = 0;
            for (let j = 0; j < addresses.length; j++) {
              if (addresses[j]?.associatedAccounts?.find(
                (obj) => obj.accountId === value.positions[i].vastAccountNumber
              )) {
                mutualFundCounter++;
              }
            }
            value.positions[i].noOfLinkedAddresses = mutualFundCounter;
          }
          if ((value.positions.filter((obj: any) => obj.noOfLinkedAddresses < 9)).length > 0) {
            value.noOfLinkedAddresses = 0;
          } else {
            value.noOfLinkedAddresses = 9;
          }
        }
      });

      allAccounts = allAccounts.filter((acc: any) => acc.productType.includes('BROKERAGE') || acc.productType.includes('MUTUAL_FUND'));
      this.store.dispatch(sendAccounts({ accounts: { accounts: allAccounts } }));
      this.isLoaderIndicate = false;

      this.thirdPartyDocAddressList = addresses.map(address => ({ ...address, optedForLabel: this.computeOptedForLabel(address) }));

      this.is529BtnEnabled = accountsData.has529Account;
      if (this.is529BtnEnabled) {
        const useAemUrl = await firstValueFrom(
          this.gatekeeperService.isFeatureSwitchedOn(environment.GATEKEEPER_529_SSO_FEATURE_ID).pipe(catchError(() => of(false)))
        );
        this.sso529Href = useAemUrl ? (this.actionButtonsContent?.[1]?.href || environment.ES529_SSO_FALLBACK_URL) : environment.ES529_SSO_FALLBACK_URL;
      }
      this.internalOnlyContent = this.isClientOnlyAction && this.is529BtnEnabled
        ? this.internal529
        : this.internalOnlyTPQ;

      if ((addressListResponse?.errors?.length ?? 0) > 0) {
        this.shouldShowErrorBanner = true;
        this.contentBody = this.errorData?.[NOT_SHOWING_DUPLICATE_ADDRESSES_ERROR_MESSAGE] || this.errorData?.[this.defaultErrorCode];
      }
    } catch (error) {
      this.shouldShowErrorBanner = true;
      this.contentBody = this.errorData?.[INFO_UNAVAILABLE_ERROR_MESSAGE_ERROR] || this.errorData?.[this.defaultErrorCode];
      this.isLoaderIndicate = false;
    }
  }

  private getThirdPartyDocuments(): Promise<GetAddressesGraphQLResponse> {
    return firstValueFrom(this.thirdPartyDocumentsService.getThirdPartyAddressList());
  }

  private getAccountsData(): Promise<any> {
    return firstValueFrom(this.thirdPartyDocumentsService.getAccounts());
  }

  actionSelected() {
    if (this.isClientOnlyAction) return;
    this.store.dispatch(
      updateAddress({
        address: {
          name: '',
          addressLine1: '',
          addressLine2: '',
          city: '',
          state: null,
          foreignAddress: false,
          foreignCountryCode: '',
          foreignCountryName: '',
          associatedAccounts: [],
        },
      }),
    );
    this.aemContentService.sendData(this.thirdpartyDocumentsCaasContent);
    this.ngZone.run(() => {
      this._router.navigate(['/address']);
    });
    this.store.dispatch(updateCurrentStep({ currentStepIndex: 1 }));
  }

  openWindow(href: string) {
    if (this.isClientOnlyAction) return;
    window.open(href, '_blank', 'menubar=no,toolbar=yes,directories=no,location=no,status=no,copyhistory=yes');
  }

  @HostListener('document:click')
  closeAllMenus() {
    this.expandedMenuIndex = null;
  }

  handleClick = (event: any, index: number) => {
    event.stopPropagation();
    this.expandedMenuIndex = this.expandedMenuIndex === index ? null : index;
  };

  changeAddress(address: InterestedPartyAddress) {
    if (this.isClientOnlyAction) return;
    this.updateAddressStore(address);
    this.store.dispatch(setOriginalAddressSnapshot({ snapshot: this.mapAddressToModel(address) }));
    this.aemContentService.sendData(this.thirdpartyDocumentsCaasContent);
    this.store.dispatch(updateCurrentStep({ currentStepIndex: 1 }));
    this.ngZone.run(() => {
      this._router.navigate(['/address']);
    });
  }

  deleteAddress(address: InterestedPartyAddress) {
    if (this.isClientOnlyAction) return;
    this.updateAddressStore(address);
    this.aemContentService.sendData(this.thirdpartyDocumentsCaasContent);
    this.ngZone.run(() => {
      this._router.navigate(['/manage-address/delete']);
    });
  }

  viewAccounts(address: InterestedPartyAddress) {
    this.updateAddressStore(address);
    this.aemContentService.sendData(this.thirdpartyDocumentsCaasContent);
    this.ngZone.run(() => {
      this._router.navigate(['/manage-address/view']);
    });
  }

  private computeOptedForLabel(address: InterestedPartyAddress): string {
    const optedFor = address.associatedAccounts?.find(a => a.interestedPartyDocumentPreference)?.interestedPartyDocumentPreference;
    const labelMap: Record<string, string> = {
      STATEMENTS: this.thirdpartyDocumentsCaasContent?.statementsOnlyLabel ?? '',
      CONFIRMATIONS: this.thirdpartyDocumentsCaasContent?.confirmationsOnlyLabel ?? '',
      STATEMENTS_CONFIRMATIONS: this.thirdpartyDocumentsCaasContent?.statementsAndConfirmationsLabel ?? '',
    };
    return optedFor ? (labelMap[optedFor] ?? '') : '';
  }

  private mapAddressToModel(address: InterestedPartyAddress): AddressModel {
    const n = address.numberNameLines || 1;
    const packed = [
      address.addressLine1 || '',
      address.addressLine2 || '',
      address.addressLine3 || '',
      address.addressLine4 || '',
      address.addressLine5 || '',
    ];
    return {
      numberNameLines: n,
      name: packed[0],
      nameLine2: n >= 2 ? packed[1] : '',
      nameLine3: n >= 3 ? packed[2] : '',
      nameLine4: n >= 4 ? packed[3] : '',
      addressLine1: packed[n] || '',
      addressLine2: packed[n + 1] || '',
      city: address.foreignAddress ? '' : (address.city || ''),
      state: address.foreignAddress ? null : (address.state || null),
      zipCode: address.foreignAddress ? '' : (address.zipCode || ''),
      zipCodePlusFour: address.foreignAddress ? '' : (address.zipCodePlusFour || ''),
      foreignAddress: address.foreignAddress,
      foreignCountryCode: address.foreignAddress ? (address.foreignCountryCode || '') : '',
      foreignCountryName: address.foreignAddress ? (address.foreignCountryName || '') : '',
      associatedAccounts: address.associatedAccounts,
    };
  }

  private updateAddressStore(address: InterestedPartyAddress) {
    this.store.dispatch(updateAddress({ address: this.mapAddressToModel(address) }));
  }
}
